export const API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? 'https://prisa.tech' : 'http://localhost:3001';
export const ALLOWED_COUNTRY = ['US', 'PK'];
export const ALLOWED_STATE = [
  'Illinois',
  'Missouri',
  'New Mexico',
  'Punjab',
  'Sindh',
];
